(() => {
  const SELECTORS = {
    buyNow: '[data-drx-buy-now]',
    gallery: 'media-gallery',
    thumbnail: '.product__thumbnail',
    currentCount: '[data-drx-media-current]'
  };

  const EXTENDED_PRODUCT_CONFIGS = {
    'product-dr-pen-a1-classic-kit': {
      title: 'A1 Classic Microneedling Pen', eyebrow: 'DR. PEN / A1 SYSTEM 01',
      positioning: 'A straightforward classic powered Dr. Pen with a dedicated A1 cartridge path and a complete storage-ready kit.',
      bridge: 'Best for buyers who want a straightforward classic powered format and a dedicated A1 replacement-cartridge path.',
      kit: 'The current package includes 1 × Dr. Pen A1 microneedling pen; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 1 × storage case; 2 × 12-needle cartridges; 2 × 36-needle cartridges; and 2 × Round Nano cartridges. Replacement cartridges are sold separately.'
    },
    'product-dr-pen-a6-professional-kit': {
      title: 'A6 Professional Microneedling Pen', eyebrow: 'DR. PEN / A6 SYSTEM 01',
      positioning: 'A professional powered Dr. Pen with dual batteries, plug-in support, and a dedicated A6 cartridge path.',
      bridge: 'Best for buyers who want dual-battery flexibility, plug-in power support, and the dedicated A6 cartridge family.',
      kit: 'The current package includes 1 × Dr. Pen A6 microneedling pen; 2 × rechargeable batteries; 1 × battery charger; 1 × plug-in head; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 1 × storage case; 2 × 12-needle cartridges; and 3 × 36-needle cartridges. Replacement cartridges are sold separately.'
    },
    'product-dr-pen-a6s-smart-kit': {
      title: 'A6S Smart Microneedling Pen', eyebrow: 'DR. PEN / A6S SYSTEM 01',
      positioning: 'A smart wireless Dr. Pen with dual batteries, plug-in support, and a dedicated A6S cartridge path.',
      bridge: 'Best for buyers who want smart wireless handling, dual-battery flexibility, and the dedicated A6S cartridge family.',
      kit: 'The current package includes 1 × Dr. Pen A6S microneedling pen; 2 × rechargeable batteries; 1 × battery charger; 1 × plug-in head; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 2 × 16-needle cartridges; 2 × 36-needle cartridges; and 2 × Round Nano cartridges. Replacement cartridges are sold separately.'
    },
    'product-dr-pen-a9-professional-kit': {
      title: 'A9 Professional Microneedling Pen', eyebrow: 'DR. PEN / A9 SYSTEM 01',
      positioning: 'A professional powered Dr. Pen with the shared M8S/A8S/A9/A11 cartridge path and a special travel case.',
      bridge: 'Best for buyers who want a professional-style body and the shared M8S/A8S/A9/A11 replacement-cartridge path.',
      kit: 'The current package includes 1 × Dr. Pen A9 microneedling pen; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 1 × special travel case; 2 × 12-needle cartridges; 2 × 36-needle cartridges; and 2 × Round Nano cartridges. Replacement cartridges are sold separately.'
    },
    'product-dr-pen-a10-wireless-kit': {
      title: 'A10 Wireless Microneedling Pen', eyebrow: 'DR. PEN / A10 SYSTEM 01',
      positioning: 'A dedicated wireless Dr. Pen with a model-specific A10 cartridge path and a complete storage-ready kit.',
      bridge: 'Best for buyers who want wireless handling and a clearly separated A10 replacement-cartridge path.',
      kit: 'The current package includes 1 × Dr. Pen A10 microneedling pen; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 1 × storage case; 2 × 12-needle cartridges; 2 × 36-needle cartridges; and 2 × Round Nano cartridges. Replacement cartridges are sold separately.'
    },
    'product-dr-pen-m7-wireless-kit': {
      title: 'M7 Wireless Microneedling Pen', eyebrow: 'DR. PEN / M7 SYSTEM 01',
      positioning: 'A compact wireless Dr. Pen with the M5/M7/N2/E30 cartridge path and a complete storage-ready kit.',
      bridge: 'Best for buyers who want compact wireless handling and the M5/M7/N2/E30 replacement-cartridge family.',
      kit: 'The current package includes 1 × Dr. Pen M7 microneedling pen; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 1 × storage case; 2 × 12-needle cartridges; 2 × 36-needle cartridges; and 2 × Round Nano cartridges. Replacement cartridges are sold separately.'
    },
    'product-dr-pen-a8s-pro-kit': {
      title: 'A8S Pro Microneedling Pen', eyebrow: 'DR. PEN / A8S SYSTEM 01',
      positioning: 'A rechargeable professional Dr. Pen with plug-in support, the shared three-slot cartridge path, and a special travel case.',
      bridge: 'Best for buyers who want rechargeable and plug-in flexibility with the shared M8S/A8S/A9/A11 cartridge family.',
      kit: 'The current package includes 1 × Dr. Pen A8S microneedling pen; 1 × rechargeable battery; 1 × plug-in head; 1 × USB charger cable (2 m); 1 × US wall charger; 1 × manual; 1 × box; 1 × special travel case; 2 × 12-needle cartridges; 2 × 36-needle cartridges; and 2 × Round Nano cartridges. Replacement cartridges are sold separately.'
    },
    'product-bio-pen-q2-ems-led-kit': {
      title: 'Bio Pen Q2 Microneedling Pen', eyebrow: 'BIO PEN / Q2 SYSTEM 01',
      positioning: 'A cartridge-based Bio Pen with EMS and LED support, a dedicated Q2 cartridge path, and an inductive-base workflow.',
      bridge: 'Best for buyers comparing microneedling with EMS and LED support while confirming the dedicated Bio Pen Q2 cartridge path.',
      kit: 'The current package includes 1 \u00D7 Bio Pen Q2 microneedling pen; 1 \u00D7 inductive base; 1 \u00D7 USB charger cable (2 m); 2 \u00D7 Q2 cartridges; and 1 \u00D7 instruction manual. Replacement cartridges are sold separately.'
    },
    'product-hydra-needle-hn20-stamp': {
      title: 'HN20 Microneedling Stamp', eyebrow: 'HYDRA NEEDLE / HN20 SYSTEM 01',
      positioning: 'A compact manual microneedling stamp with four listed depth choices and independent 1, 3, 5, or 10-piece pack options.',
      bridge: 'Best for buyers choosing a manual stamp by depth and pack quantity before adding a selected HN20 configuration to their routine.',
      kit: 'The selected HN20 variant determines the listed depth and pack quantity. Confirm the exact selected configuration before purchase.'
    },
    'product-hydra-needle-hn25a-stamp': {
      title: 'HN25 Microneedling Stamp', eyebrow: 'HYDRA NEEDLE / HN25 SYSTEM 01',
      positioning: 'A compact manual microneedling stamp offered in four listed depth configurations for a direct single-product purchase path.',
      bridge: 'Best for buyers choosing a compact manual stamp by depth while keeping the HN25 product path separate from powered pens and cartridges.',
      kit: 'The selected HN25 variant determines the listed depth. Confirm the exact selected configuration and package contents before purchase.'
    },
    'product-hydra-needle-hn30-adjustable-stamp': {
      title: 'HN30 Adjustable Microneedling Stamp', eyebrow: 'HYDRA NEEDLE / HN30 SYSTEM 01',
      positioning: 'An adjustable manual stamp system with complete-device, multi-device, replacement-head, and combined purchase options.',
      bridge: 'Best for buyers comparing an adjustable HN30 stamp, multi-device quantities, and HN30-specific replacement-head planning.',
      kit: 'The selected HN30 variant determines whether the order contains a complete stamp, multiple stamps, replacement needle heads, or the listed combination.'
    },
    'product-bio-needle-h24-adjustable-stamp': {
      title: 'H24 Microneedling Stamp', eyebrow: 'BIO NEEDLE / H24 SYSTEM 01',
      positioning: 'A fixed 24-pin manual microneedling stamp in one listed product configuration, separate from powered pens and replacement cartridges.',
      bridge: 'Best for buyers choosing a simple 24-pin manual stamp in the current single listed H24 configuration.',
      kit: 'H24 is currently listed as one complete manual stamp configuration. Confirm any included accessories and retail packaging before purchase.'
    }
  };

  const getExtendedProductConfig = () => Object.entries(EXTENDED_PRODUCT_CONFIGS)
    .find(([className]) => document.body.classList.contains(className))?.[1] || null;

  const getProductForm = (button) => {
    const formId = button.dataset.productForm;
    return formId ? document.getElementById(formId) : button.closest('.drx-purchase-system')?.querySelector('form[action*="/cart/add"]');
  };

  const setBuyNowState = (button, status, loading) => {
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', String(loading));
    const statusNode = button.parentElement?.querySelector('[data-drx-buy-now-status]');
    if (statusNode) statusNode.textContent = status;
  };

  const showProductError = (form, message) => {
    const error = form?.querySelector('.product-form__error-message');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  };

  const buyNow = async (button) => {
    const form = getProductForm(button);
    const variantInput = form?.querySelector('[name="id"]');
    const quantityInput = form?.querySelector('[name="quantity"]');
    const sellingPlanInput = form?.querySelector('[name="selling_plan"]:checked, [name="selling_plan"]');
    const variantId = Number(variantInput?.value);
    const quantity = Math.max(1, Number(quantityInput?.value) || 1);

    if (!form || !variantId) {
      showProductError(form, 'Please select an available product option.');
      return;
    }

    const item = { id: variantId, quantity };
    if (sellingPlanInput?.value) item.selling_plan = Number(sellingPlanInput.value);

    setBuyNowState(button, 'Preparing secure checkout…', true);

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item] })
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Unable to start checkout.');
      }

      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Unable to start checkout.';
      showProductError(form, message);
      setBuyNowState(button, message, false);
    }
  };

  const hydrateBuyNowButtons = (root = document) => {
    root.querySelectorAll(SELECTORS.buyNow).forEach((button) => {
      if (button.dataset.drxBuyNowReady === 'true') return;
      button.dataset.drxBuyNowReady = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (!button.disabled) buyNow(button);
      });
    });
  };

  /*
   * Quantity is a conversion-critical control, so this layer owns its button
   * behavior instead of depending on a custom-element upgrade that can fail.
   * Capture-phase listeners stop the base handler and guarantee one step only.
   */
  const hydrateQuantityInputs = (root = document) => {
    root.querySelectorAll('quantity-input').forEach((quantity) => {
      if (quantity.dataset.drxQuantityReady === 'true') return;

      const input = quantity.querySelector('input[name="quantity"]');
      if (!input) return;

      quantity.dataset.drxQuantityReady = 'true';
      quantity.querySelectorAll('.quantity__button').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          const step = Math.max(1, Number(input.step) || 1);
          const minimum = Number(input.min || input.dataset.min) || 1;
          const maximum = input.max === '' ? Number.POSITIVE_INFINITY : Number(input.max);
          const current = Number(input.value) || minimum;
          const next = button.name === 'plus'
            ? Math.min(maximum, current + step)
            : Math.max(minimum, current - step);

          input.value = String(next);
          quantity.querySelector('[name="minus"]')?.toggleAttribute('disabled', next <= minimum);
          quantity.querySelector('[name="plus"]')?.toggleAttribute('disabled', next >= maximum);

          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, true);
      });
    });
  };

  const updateGalleryCount = (gallery) => {
    const current = gallery.querySelector(`${SELECTORS.thumbnail}[aria-current="true"]`);
    const visible = [...gallery.querySelectorAll(SELECTORS.thumbnail)].filter((thumbnail) => !thumbnail.hidden);
    const index = Math.max(0, visible.indexOf(current));
    const count = gallery.querySelector(SELECTORS.currentCount);
    if (count) count.textContent = String(index + 1);
  };

  const alignActiveThumbnail = (gallery) => {
    const current = gallery.querySelector(`${SELECTORS.thumbnail}[aria-current="true"]`);
    const rail = current?.closest('.product__thumbnails-list');
    if (!current || !rail) return;

    if (rail.scrollWidth > rail.clientWidth) {
      const left = Math.max(0, current.offsetLeft - rail.offsetLeft);
      rail.scrollTo({ left, behavior: 'auto' });
    }
    if (rail.scrollHeight > rail.clientHeight) {
      const top = Math.max(0, current.offsetTop - rail.offsetTop);
      rail.scrollTo({ top, behavior: 'auto' });
    }
  };

  const syncM8GalleryPagination = (gallery) => {
    const pagination = gallery.querySelector('[data-m8-gallery-pagination]');
    if (!pagination) return;

    const thumbnails = [...gallery.querySelectorAll(SELECTORS.thumbnail)].filter((thumbnail) => !thumbnail.hidden);
    if (pagination.children.length !== thumbnails.length) {
      const dots = thumbnails.map((thumbnail, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'm8-gallery-dot';
        dot.setAttribute('aria-label', thumbnail.getAttribute('aria-label') || `View media ${index + 1}`);
        dot.addEventListener('click', () => thumbnail.click());
        return dot;
      });
      pagination.replaceChildren(...dots);
    }

    const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true');
    [...pagination.children].forEach((dot, index) => {
      const isActive = index === Math.max(0, activeIndex);
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const hydrateGallery = (gallery) => {
    updateGalleryCount(gallery);
    alignActiveThumbnail(gallery);
    syncM8GalleryPagination(gallery);
    if (gallery.dataset.drxGalleryReady === 'true') return;
    gallery.dataset.drxGalleryReady = 'true';
    const observer = new MutationObserver(() => {
      updateGalleryCount(gallery);
      alignActiveThumbnail(gallery);
      syncM8GalleryPagination(gallery);
    });
    gallery.querySelectorAll(SELECTORS.thumbnail).forEach((thumbnail) => {
      observer.observe(thumbnail, { attributes: true, attributeFilter: ['aria-current', 'hidden'] });
    });
  };

  const hydrateM8WhyRail = (root = document) => {
    if (!document.body.classList.contains('drpenx-product-golden')) return;

    root.querySelectorAll('[data-m8-why-rail]').forEach((rail) => {
      const items = [...rail.querySelectorAll('.m8-why__item')];
      const pagination = rail.parentElement?.querySelector('[data-m8-why-pagination]');
      const current = pagination?.querySelector('[data-m8-why-current]');
      const progress = pagination?.querySelector('[data-m8-why-progress]');
      if (!items.length || !current || !progress) return;

      const setActiveItem = () => {
        const activeIndex = items.reduce((closestIndex, item, index) => {
          const currentDistance = Math.abs(items[closestIndex].offsetLeft - rail.scrollLeft);
          const nextDistance = Math.abs(item.offsetLeft - rail.scrollLeft);
          return nextDistance < currentDistance ? index : closestIndex;
        }, 0);
        current.textContent = String(activeIndex + 1).padStart(2, '0');
        progress.style.setProperty('--m8-why-progress', `${((activeIndex + 1) / items.length) * 100}%`);
      };

      setActiveItem();
      if (rail.dataset.m8WhyReady === 'true') return;
      rail.dataset.m8WhyReady = 'true';

      let frame;
      rail.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(setActiveItem);
      }, { passive: true });
      rail.addEventListener('keydown', (event) => {
        if (rail.scrollWidth <= rail.clientWidth + 1) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const activeIndex = items.reduce((closestIndex, item, index) => {
          const currentDistance = Math.abs(items[closestIndex].offsetLeft - rail.scrollLeft);
          const nextDistance = Math.abs(item.offsetLeft - rail.scrollLeft);
          return nextDistance < currentDistance ? index : closestIndex;
        }, 0);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const targetIndex = Math.max(0, Math.min(items.length - 1, activeIndex + direction));
        rail.scrollTo({ left: items[targetIndex].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      });
    });
  };

  const hydrateProductCommercialRow = (root = document) => {
    if (!document.body.classList.contains('drpenx-product-design')) return;
    root.querySelectorAll('.drx-product-panel').forEach((panel) => {
      if (document.body.classList.contains('product-dr-pen-ultima-m8')) {
        const title = panel.querySelector('.drx-product-identity .heading');
        if (title) title.textContent = 'M8 Ultima Microneedling Pen';

        const eyebrow = panel.querySelector('.product__text.first .rte');
        if (eyebrow) eyebrow.textContent = 'DR. PEN / M8 SYSTEM 01';
      } else if (document.body.classList.contains('product-dr-pen-m8s-wireless-kit')) {
        const title = panel.querySelector('.drx-product-identity .heading');
        if (title) title.textContent = 'M8S Wireless Microneedling Pen';

        const eyebrow = panel.querySelector('.product__vendor');
        if (eyebrow) eyebrow.textContent = 'DR. PEN / M8S SYSTEM 01';

        let positioning = [...panel.querySelectorAll('.product__text')].find((node) => node.querySelector('.text-sm'));
        if (!positioning) {
          positioning = document.createElement('div');
          positioning.className = 'product__text drx-m8-positioning';
          positioning.innerHTML = '<div class="product__text-inner"><p class="rte text-sm leading-tight"></p></div>';
          panel.querySelector('.drx-product-identity')?.after(positioning);
        }
        const positioningText = positioning.querySelector('.text-sm');
        if (positioningText) positioningText.textContent = 'A six-level wireless Dr. Pen with USB-C charging, visible depth control, and the newer M8S three-slot cartridge path.';
      } else if (document.body.classList.contains('product-dr-pen-a11-ultima-pro-microneedling-pen')) {
        const title = panel.querySelector('.drx-product-identity .heading');
        if (title) title.textContent = 'A11 Ultima Pro Microneedling Pen';

        const eyebrow = panel.querySelector('.product__vendor') || panel.querySelector('.product__text.first .rte');
        if (eyebrow) eyebrow.textContent = 'DR. PEN / A11 SYSTEM 01';

        let positioning = [...panel.querySelectorAll('.product__text')].find((node) => node.querySelector('.text-sm'));
        if (!positioning) {
          positioning = document.createElement('div');
          positioning.className = 'product__text drx-m8-positioning';
          positioning.innerHTML = '<div class="product__text-inner"><p class="rte text-sm leading-tight"></p></div>';
          panel.querySelector('.drx-product-identity')?.after(positioning);
        }
        const positioningText = positioning.querySelector('.text-sm');
        if (positioningText) positioningText.textContent = 'A powered-base Dr. Pen with touchscreen six-level control and the shared M8S/A8S/A9/A11 three-slot cartridge path.';
      } else if (document.body.classList.contains('product-hydra-pen-h3-automatic-kit')) {
        const title = panel.querySelector('.drx-product-identity .heading');
        if (title) title.textContent = 'Hydra Pen H3 Serum Microneedling Pen';

        const eyebrow = panel.querySelector('.product__vendor') || panel.querySelector('.product__text.first .rte');
        if (eyebrow) eyebrow.textContent = 'HYDRA PEN / H3 SYSTEM 01';

        let positioning = [...panel.querySelectorAll('.product__text')].find((node) => node.querySelector('.text-sm'));
        if (!positioning) {
          positioning = document.createElement('div');
          positioning.className = 'product__text drx-m8-positioning';
          positioning.innerHTML = '<div class="product__text-inner"><p class="rte text-sm leading-tight"></p></div>';
          panel.querySelector('.drx-product-identity')?.after(positioning);
        }
        const positioningText = positioning.querySelector('.text-sm');
        if (positioningText) positioningText.textContent = 'An automatic microneedling and serum-flow Hydra Pen with the shared H3/H5 cartridge path and a complete travel-ready kit.';
      } else if (document.body.classList.contains('product-hydra-pen-h5-ems-kit')) {
        const title = panel.querySelector('.drx-product-identity .heading');
        if (title) title.textContent = 'Hydra Pen H5 EMS Serum Microneedling Pen';

        const eyebrow = panel.querySelector('.product__vendor') || panel.querySelector('.product__text.first .rte');
        if (eyebrow) eyebrow.textContent = 'HYDRA PEN / H5 SYSTEM 01';

        let positioning = [...panel.querySelectorAll('.product__text')].find((node) => node.querySelector('.text-sm'));
        if (!positioning) {
          positioning = document.createElement('div');
          positioning.className = 'product__text drx-m8-positioning';
          positioning.innerHTML = '<div class="product__text-inner"><p class="rte text-sm leading-tight"></p></div>';
          panel.querySelector('.drx-product-identity')?.after(positioning);
        }
        const positioningText = positioning.querySelector('.text-sm');
        if (positioningText) positioningText.textContent = 'An EMS-supported microneedling and serum-flow Hydra Pen with the shared H3/H5 cartridge path and a complete travel-ready kit.';
      } else {
        const extendedConfig = getExtendedProductConfig();
        if (extendedConfig) {
          const title = panel.querySelector('.drx-product-identity .heading');
          if (title) title.textContent = extendedConfig.title;

          const eyebrow = panel.querySelector('.product__vendor') || panel.querySelector('.product__text.first .rte');
          if (eyebrow) eyebrow.textContent = extendedConfig.eyebrow;

          let positioning = [...panel.querySelectorAll('.product__text')].find((node) => node.querySelector('.text-sm'));
          if (!positioning) {
            positioning = document.createElement('div');
            positioning.className = 'product__text drx-m8-positioning';
            positioning.innerHTML = '<div class="product__text-inner"><p class="rte text-sm leading-tight"></p></div>';
            panel.querySelector('.drx-product-identity')?.after(positioning);
          }
          const positioningText = positioning.querySelector('.text-sm');
          if (positioningText) positioningText.textContent = extendedConfig.positioning;
        }
      }

      if (panel.querySelector('.drx-m8-commerce-stack')) return;

      const rating = panel.querySelector('.product__rating');
      const price = panel.querySelector('.product__price');
      if (!price) return;

      const positioning = [...panel.querySelectorAll('.product__text')].find((node) => node.querySelector('.text-sm'));
      const identity = panel.querySelector('.drx-product-identity');
      const stack = document.createElement('div');
      stack.className = 'drx-m8-commerce-stack';

      if (positioning?.parentNode) {
        positioning.after(stack);
      } else if (identity?.parentNode) {
        identity.after(stack);
      } else {
        price.parentNode.insertBefore(stack, price);
      }

      if (rating) stack.append(rating);
      stack.append(price);

    });
  };

  const hydrateM8StickyPurchase = (root = document) => {
    const isM8Family = document.body.classList.contains('product-dr-pen-ultima-m8')
      || document.body.classList.contains('product-dr-pen-m8s-wireless-kit')
      || document.body.classList.contains('product-dr-pen-a11-ultima-pro-microneedling-pen')
      || document.body.classList.contains('product-hydra-pen-h3-automatic-kit')
      || document.body.classList.contains('product-hydra-pen-h5-ems-kit')
      || Boolean(getExtendedProductConfig());
    if (!isM8Family) return;
    root.querySelectorAll('[data-m8-mobile-sticky]').forEach((sticky) => {
      if (sticky.dataset.ready === 'true') return;
      const stickyQuantity = sticky.querySelector('[data-m8-sticky-quantity]');
      const mainQuantity = document.querySelector('.drx-purchase-system input[name="quantity"]');
      if (!stickyQuantity || !mainQuantity) return;

      sticky.dataset.ready = 'true';
      stickyQuantity.value = mainQuantity.value || '1';
      const syncMain = () => {
        mainQuantity.value = stickyQuantity.value || '1';
        mainQuantity.dispatchEvent(new Event('input', { bubbles: true }));
        mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      };
      stickyQuantity.addEventListener('input', syncMain);
      stickyQuantity.addEventListener('change', syncMain);
      mainQuantity.addEventListener('change', () => {
        stickyQuantity.value = mainQuantity.value || '1';
      });

      const purchase = document.querySelector('.drx-purchase-system');
      if (!purchase) return;

      const mobileQuery = window.matchMedia('(max-width: 1023px)');
      let frame = 0;
      const getVisibleFooter = () => [...document.querySelectorAll('footer.footer, footer, .footer')]
        .find((footer) => footer.offsetHeight > 0 && window.getComputedStyle(footer).display !== 'none');
      const setVisible = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.inert = !visible;
        if (!visible && sticky.contains(document.activeElement)) document.activeElement.blur();
      };
      const syncSticky = () => {
        frame = 0;
        const purchaseRect = purchase.getBoundingClientRect();
        const footer = getVisibleFooter();
        const footerRect = footer?.getBoundingClientRect();
        const stickyHeight = sticky.offsetHeight || 76;
        const afterPurchase = purchaseRect.bottom < 0;
        const beforeFooter = !footerRect || footerRect.top > window.innerHeight - stickyHeight;
        setVisible(mobileQuery.matches && afterPurchase && beforeFooter);
      };
      const scheduleSync = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(syncSticky);
      };

      window.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync, { passive: true });
      window.addEventListener('pageshow', scheduleSync);
      window.addEventListener('hashchange', scheduleSync);
      window.addEventListener('popstate', scheduleSync);
      window.visualViewport?.addEventListener('resize', scheduleSync, { passive: true });
      mobileQuery.addEventListener?.('change', scheduleSync);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(scheduleSync, { threshold: 0 });
        observer.observe(purchase);
        const footer = getVisibleFooter();
        if (footer) observer.observe(footer);
      }

      syncSticky();
    });
  };

  const hydrateCartridgeCanvas = (root = document) => {
    root.querySelectorAll('[data-cx-cartridge-canvas]').forEach((canvas) => {
      if (canvas.dataset.ready === 'true') return;
      canvas.dataset.ready = 'true';

      const gallerySlides = [...canvas.querySelectorAll('[data-cx-slide]')];
      const galleryControls = [...canvas.querySelectorAll('[data-cx-gallery-control]')];
      const galleryCount = canvas.querySelector('[data-cx-gallery-count]');
      const setGalleryIndex = (index) => {
        const nextIndex = Number(index);
        gallerySlides.forEach((slide) => slide.classList.toggle('is-active', Number(slide.dataset.cxSlide) === nextIndex));
        galleryControls.forEach((control) => {
          const active = Number(control.dataset.cxGalleryControl) === nextIndex;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-pressed', String(active));
        });
        if (galleryCount) galleryCount.textContent = `${nextIndex + 1} / ${gallerySlides.length}`;
      };
      galleryControls.forEach((control) => {
        control.addEventListener('click', () => setGalleryIndex(control.dataset.cxGalleryControl));
      });

      const sourceOptions = [...canvas.querySelectorAll('[data-cx-option-picker] [data-cx-variant]')];
      const familyTargets = {
        needle: canvas.querySelector('[data-cx-family-options="needle"]'),
        nano: canvas.querySelector('[data-cx-family-options="nano"]')
      };
      sourceOptions.forEach((option) => {
        const family = option.dataset.cxTitle.toLowerCase().startsWith('nano') ? 'nano' : 'needle';
        const clone = option.cloneNode(true);
        clone.classList.add('cx-option--family');
        familyTargets[family]?.append(clone);
      });

      const variantInput = canvas.querySelector('[data-cx-variant-input]');
      const selectedTitle = canvas.querySelector('[data-cx-selected-title]');
      const price = canvas.querySelector('[data-cx-price]');
      const saleMeta = canvas.querySelector('[data-cx-sale-meta]');
      const comparePrice = canvas.querySelector('[data-cx-compare-price]');
      const savings = canvas.querySelector('[data-cx-savings]');
      const stickyPrice = canvas.querySelector('[data-cx-sticky-price]');
      const selectionStatus = canvas.querySelector('[data-cx-selection-status]');
      const bridgeTitle = canvas.querySelector('[data-cx-bridge-title]');
      const contentsTitle = canvas.querySelector('[data-cx-contents-title]');
      const addButton = canvas.querySelector('[data-cx-add]');
      const addButtonLabel = addButton?.querySelector('span');
      const buyNowButton = canvas.querySelector('[data-drx-buy-now]');
      const stickyAddButton = canvas.querySelector('[data-cx-sticky-add]');
      const stickyAddLabel = stickyAddButton?.querySelector('span');
      const addToCartLabel = canvas.dataset.cxAddToCartLabel || 'Add to cart';
      const soldOutLabel = canvas.dataset.cxSoldOutLabel || 'Sold out';
      const fillTemplate = (template, value) => (template || '').replace('__OPTION__', value);
      const selectVariant = (option) => {
        const variantId = option.dataset.cxVariant;
        const title = option.dataset.cxTitle;
        const formattedPrice = option.dataset.cxPrice;
        const available = option.dataset.cxAvailable === 'true';
        canvas.querySelectorAll('[data-cx-variant]').forEach((candidate) => {
          const active = candidate.dataset.cxVariant === variantId;
          candidate.classList.toggle('is-selected', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (selectedTitle) selectedTitle.textContent = title;
        if (price) price.textContent = formattedPrice;
        const onSale = option.dataset.cxOnSale === 'true';
        if (saleMeta) saleMeta.hidden = !onSale;
        if (comparePrice) comparePrice.textContent = onSale ? option.dataset.cxComparePrice : '';
        if (savings) savings.textContent = onSale ? option.dataset.cxSavings : '';
        if (stickyPrice) stickyPrice.textContent = formattedPrice;
        if (selectionStatus) selectionStatus.textContent = fillTemplate(canvas.dataset.cxSelectedStatusTemplate, title);
        if (bridgeTitle) bridgeTitle.textContent = fillTemplate(canvas.dataset.cxBridgeTemplate, title);
        if (contentsTitle) contentsTitle.textContent = fillTemplate(canvas.dataset.cxContentsTemplate, title);
        if (addButton) addButton.disabled = !available;
        if (addButtonLabel) addButtonLabel.textContent = available ? addToCartLabel : soldOutLabel;
        if (buyNowButton) buyNowButton.disabled = !available;
        if (stickyAddButton) stickyAddButton.disabled = !available;
        if (stickyAddLabel) stickyAddLabel.textContent = available ? addToCartLabel : soldOutLabel;
      };
      canvas.addEventListener('click', (event) => {
        const option = event.target.closest('[data-cx-variant]');
        if (option && canvas.contains(option) && !option.disabled) selectVariant(option);
      });

      const quantityInput = canvas.querySelector('[data-cx-quantity]');
      const stickyQuantity = canvas.querySelector('[data-cx-sticky-quantity]');
      const syncQuantity = (value) => {
        const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
        if (quantityInput) quantityInput.value = String(quantity);
        if (stickyQuantity) stickyQuantity.textContent = String(quantity);
        return quantity;
      };
      canvas.querySelectorAll('[data-cx-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          syncQuantity((Number.parseInt(quantityInput?.value, 10) || 1) + Number(button.dataset.cxQuantityChange));
          quantityInput?.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      canvas.querySelectorAll('[data-cx-sticky-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          syncQuantity((Number.parseInt(quantityInput?.value, 10) || 1) + Number(button.dataset.cxStickyQuantityChange));
          quantityInput?.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      quantityInput?.addEventListener('input', () => syncQuantity(quantityInput.value));
      quantityInput?.addEventListener('change', () => syncQuantity(quantityInput.value));

      canvas.querySelector('[data-cx-sticky-add]')?.addEventListener('click', () => {
        canvas.querySelector('[data-cx-add]')?.click();
      });

      const sticky = canvas.querySelector('[data-cx-mobile-sticky]');
      const purchaseAnchor = canvas.querySelector('[data-cx-purchase-anchor]');
      if (sticky && purchaseAnchor && 'IntersectionObserver' in window) {
        const syncSticky = () => {
          const rect = purchaseAnchor.getBoundingClientRect();
          const visible = rect.bottom < 0;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
        };
        const observer = new IntersectionObserver(([entry]) => {
          const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
        }, { threshold: 0 });
        observer.observe(purchaseAnchor);
        window.addEventListener('scroll', syncSticky, { passive: true });
        syncSticky();
      }
    });
  };

  const hydrateEditorialCopy = (root = document) => {
    const isM8 = document.body.classList.contains('product-dr-pen-ultima-m8');
    const isA11 = document.body.classList.contains('product-dr-pen-a11-ultima-pro-microneedling-pen');
    const extendedConfig = getExtendedProductConfig();
    const hydraModel = document.body.classList.contains('product-hydra-pen-h3-automatic-kit')
      ? 'H3'
      : document.body.classList.contains('product-hydra-pen-h5-ems-kit') ? 'H5' : '';
    if (!isM8 && !isA11 && !hydraModel && !extendedConfig) return;

    const bridgeHeading = root.querySelector('[data-drpenx-bridge-fallback] h2');
    const bridgeCopy = bridgeHeading?.nextElementSibling;
    if (bridgeCopy?.matches('p')) {
      bridgeCopy.textContent = extendedConfig
        ? extendedConfig.bridge
        : isA11
          ? 'Best for buyers who prefer a powered inductive-base workflow, touchscreen control, and the shared M8S/A8S/A9/A11 three-slot cartridge path.'
          : isM8
            ? 'Best for buyers choosing an all-rounder Dr. Pen model and confirming the M8/M7S cartridge path before replacement planning.'
            : `Best for buyers choosing a ${hydraModel === 'H5' ? 'serum-flow device with EMS support' : 'simpler automatic serum-flow device'} and confirming the shared H3/H5 cartridge path before replacement planning.`;
    }

    root.querySelectorAll('.drx-geo-chapter').forEach((chapter) => {
      const heading = chapter.querySelector('summary h2, summary h3');
      const targetHeading = isA11 || extendedConfig ? 'What to confirm in the kit' : "What's included";
      if (heading?.textContent.trim() !== targetHeading) return;
      const firstParagraph = chapter.querySelector('.drx-geo-chapter__body p');
      if (firstParagraph) {
        firstParagraph.textContent = isM8
          ? 'The current package includes 1 \u00D7 Dr. Pen M8 microneedling pen; 1 \u00D7 USB charger cable (2 m); 1 \u00D7 US wall charger; 1 \u00D7 manual; 1 \u00D7 box; 1 \u00D7 storage case; 2 \u00D7 16-needle cartridges; 2 \u00D7 36-needle cartridges; and 2 \u00D7 Round Nano cartridges. Replacement cartridges are sold separately.'
          : extendedConfig
          ? extendedConfig.kit
          : isA11
            ? 'The current package includes 1 \u00D7 Dr. Pen A11 microneedling pen; 1 \u00D7 inductive base; 1 \u00D7 USB charger cable (2 m); 1 \u00D7 US wall charger; 1 \u00D7 manual; 1 \u00D7 box; 2 \u00D7 18-needle cartridges; 2 \u00D7 36-needle cartridges; and 2 \u00D7 Round Nano cartridges. Replacement cartridges are sold separately.'
            : `The current package includes 1 \u00D7 Dr. Pen Hydra ${hydraModel} Serum microneedling pen; 2 \u00D7 cartridges for Dr. Pen Hydra ${hydraModel}; 1 \u00D7 US charger adapter; 1 \u00D7 USB charger cable; 1 \u00D7 instruction manual; and 1 \u00D7 travel case. Replacement cartridges are sold separately.`;
      }
    });
  };

  hydrateBuyNowButtons();
  hydrateQuantityInputs();
  hydrateProductCommercialRow();
  hydrateM8StickyPurchase();
  hydrateCartridgeCanvas();
  hydrateEditorialCopy();
  hydrateM8WhyRail();
  document.querySelectorAll(SELECTORS.gallery).forEach(hydrateGallery);
  document.addEventListener('shopify:section:load', (event) => {
    hydrateBuyNowButtons(event.target);
    hydrateQuantityInputs(event.target);
    hydrateProductCommercialRow(event.target);
    hydrateM8StickyPurchase(event.target);
    hydrateCartridgeCanvas(event.target);
    hydrateEditorialCopy(event.target);
    hydrateM8WhyRail(event.target);
    event.target.querySelectorAll(SELECTORS.gallery).forEach(hydrateGallery);
  });
})();
